import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconEnvelope } from '../../assets/icons/IconEnvelope';
import { useAppNavigate } from '../../hooks/useAppNavigate';
import { TranslationKey } from '../../i18n/translationKeys';
import { IGNORED_RELANCES_ROUTE } from '../../routes/paths';
import { useLanguageStore } from '../../stores/languageStore';
import { LinkButton } from '../../ui/LinkButton/LinkButton';
import { formatCurrency } from '../../utils/formatters';
import type { IgnoredRelancesSummaryProps } from './types';

export const IgnoredRelancesSummary: React.FC<IgnoredRelancesSummaryProps> = ({ ignored }) => {
    const { t } = useTranslation();
    const lang = useLanguageStore(s => s.lang);
    const appNavigate = useAppNavigate();

    if (ignored.length === 0) return null;

    const total = ignored.reduce((sum, e) => sum + (e.item.totalDue ?? 0), 0);

    return (
        <p data-testid="home-ignored-relances-summary" className="flex items-start gap-s text-m font-medium text-content-subtle">
            <span className="flex h-lh shrink-0 items-center">
                <IconEnvelope className="size-4 text-icon-muted" />
            </span>
            <span>
                {t(TranslationKey.Home.Agenda.IgnoredSummary, { count: ignored.length, amount: formatCurrency(total, lang) })}
                {' — '}
                <LinkButton
                    variant="navigation"
                    weight="medium"
                    data-testid="home-ignored-relances-link"
                    onClick={() => appNavigate(IGNORED_RELANCES_ROUTE)}
                >
                    {t(TranslationKey.Home.Agenda.IgnoredSeeList)}
                </LinkButton>
            </span>
        </p>
    );
};
